import { gql } from "@apollo/client";
import { createPageInfo } from "./helper";
import { PALETTE_SCHEMAS } from "@/lib/constants";
export const typeDef = gql`
  type PaletteObject {
    id: Int
    type: String
    meta: Meta
    advertising: Advert
  }

  type Palette {
    palette_id: ID!
    name: String
    id_key: String
    header: String
    description: String
    schema_id: Int
    schema: String
    values: JSONObject
  }

  type PaletteObjectConnection {
    data: [PaletteObject]
    pageInfo: PageInfo
  }

  type Query {
    palette(id: Int): Palette
    paletteObjects(id: Int, offset: Int, limit: Int): PaletteObjectConnection
  }
`;
export const resolvers = {
  Query: {
    palette: async (_parent, _ref, _ref2) => {
      let {
        id
      } = _ref;
      let {
        dataSources
      } = _ref2;
      try {
        return await dataSources.palette.getPalette(id);
      } catch (e) {
        var _e$extensions, _e$extensions2;
        if (e !== null && e !== void 0 && (_e$extensions = e.extensions) !== null && _e$extensions !== void 0 && _e$extensions.response && (e === null || e === void 0 || (_e$extensions2 = e.extensions) === null || _e$extensions2 === void 0 || (_e$extensions2 = _e$extensions2.response) === null || _e$extensions2 === void 0 ? void 0 : _e$extensions2.status) !== 404) {
          console.log(e.extensions.response);
        }
        return null;
      }
    },
    paletteObjects: async (_parent, _ref3, _ref4) => {
      let {
        id,
        offset,
        limit
      } = _ref3;
      let {
        dataSources
      } = _ref4;
      try {
        const result = await dataSources.palette.paletteObjects(id, offset, limit);
        return {
          data: result.objects,
          pageInfo: createPageInfo({
            limit,
            offset,
            count: result.total_count
          })
        };
      } catch (e) {
        var _e$extensions3, _e$extensions4;
        if (e !== null && e !== void 0 && (_e$extensions3 = e.extensions) !== null && _e$extensions3 !== void 0 && _e$extensions3.response && (e === null || e === void 0 || (_e$extensions4 = e.extensions) === null || _e$extensions4 === void 0 || (_e$extensions4 = _e$extensions4.response) === null || _e$extensions4 === void 0 ? void 0 : _e$extensions4.status) !== 404) {
          console.log(e.extensions.response);
        }
        return {
          data: [],
          pageInfo: createPageInfo({
            limit,
            offset,
            count: 0
          })
        };
      }
    }
  },
  Palette: {
    schema: palette => PALETTE_SCHEMAS[palette.schema_id]
  }
};